import { useEffect } from "react"
import { fetchContracts } from "store/contracts/actions"
import { useSelector } from "react-redux"
import { useActions } from "store/utils"

export default function ContractsFetcher() {
  const actions = useActions({
    fetchContracts: () => fetchContracts(),
  })

  const { authenticated } = useSelector((state) => state.app)
  const { isLoaded, isLoading } = useSelector((state) => state.contracts)

  useEffect(() => {
    if (authenticated && !isLoaded && !isLoading) {
      actions.fetchContracts()
    }
  }, [actions, authenticated, isLoaded, isLoading])

  return false
}
